import { useStaticQuery, graphql } from 'gatsby'

// :::: GET Article from Article title ::::
export const getStrapiEventFromTitle = title => {
  const { event, blog, video } = useStaticQuery(allStrapiBlogCategoryQuery)
  const list = [...blog.nodes, ...event.nodes, ...video.nodes]
  const item = list.filter(node => node.title === title)
  return item[0] || {}
}

const allStrapiBlogCategoryQuery = graphql`
  query {
    event: allStrapiEvent {
      nodes {
        title
        body {
          data {
            body
          }
        }
        categories {
          name
          color
          slug
          type
        }
        excerpt {
          data {
            excerpt
          }
        }
      }
    }
    blog: allStrapiBlog {
      nodes {
        title
        body {
          data {
            body
          }
        }
        categories {
          name
          color
          slug
          type
        }
        excerpt {
          data {
            excerpt
          }
        }
      }
    }
    video: allStrapiVideo {
      nodes {
        title
        body {
          data {
            body
          }
        }
        categories {
          name
          color
          slug
          type
        }
        excerpt {
          data {
            excerpt
          }
        }
      }
    }
  }
`
